import {IComponentOptions, ILogService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {IModalInstanceService} from "angular-ui-bootstrap";
import {Application} from "../../../model/Application";
import {LoadingService} from "../../../loading/loading.service";
import {ApplicationService} from "../../application.service";

class ReleaseApplicationModalController {

    public modalInstance: IModalInstanceService;
    public resolve: any;
    public close: any;
    public dismiss: any;
    public application: Application;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $state: StateService,
                private toaster: any,
                private loadingService: LoadingService,
                private applicationService: ApplicationService) {
    }

    public $onInit() {
        this.application = this.resolve.application;
    }

    public submit() {
        this.$log.info("submit()");
        this.loadingService.show();

        this.applicationService.releaseToFacultyAdmin(this.application.id)
            .then((application) => {
                this.$log.debug("releaseApplication:", application);

                this.application = application;

                this.toaster.pop({type: "success", title: "Application released"});
                this.close({$value: application});
                this.$state.go("staff.dashboard", {}, {reload: true});

            })
            .finally(() => {
                    this.loadingService.hide();
                }
            );
    }

    public cancel() {
        this.dismiss({$value: "cancelled by user"});
    }

}

export const ReleaseApplicationModalComponent: IComponentOptions = {
    bindings: {
        modalInstance: "<",
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: ReleaseApplicationModalController,
    template: require("./release-modal.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/application/modals/release-modal/release-modal.component.ts